import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const Apply = () => {
  return (
    <div className="apply-page">
      
      {/* 1. UNIFIED HERO SECTION */}
      <section className="apply-hero">
        <div className="container text-center">
          <h1>Submit Your Application</h1>
          <p className="subtitle">
            Take the next step in your security career with Nightmark.
          </p>
        </div>
      </section>

      {/* 2. APPLICATION FORM SECTION */}
      <section className="apply-form-section bg-light" style={{ padding: '6rem 0' }}>
        <div className="container">
          
          {/* Back button to go to jobs */}
          <div style={{ marginBottom: '2rem' }}>
            <Link to="/careers" style={{ fontWeight: '600', color: 'var(--color-primary-navy)' }}>
              ← Back to Current Vacancies
            </Link>
          </div>

          <div className="apply-form-container bg-white" style={{ position: 'relative', overflow: 'hidden' }}>
            
            {/* Decorative Chevron on the form */}
            <div style={{ position: 'absolute', top: '-40px', right: '-20px', fontSize: '10rem', color: 'var(--color-secondary-light)', fontWeight: '800', lineHeight: '1', zIndex: '0', pointerEvents: 'none' }}>
              »
            </div>

            <div style={{ position: 'relative', zIndex: '1' }}>
              <h2 style={{ marginBottom: '0.5rem' }}>Applicant Details</h2>
              <p style={{ marginBottom: '2.5rem' }}>Please fill out all required fields and attach an up-to-date CV.</p>

              {/* Vetting Warning Box */}
              <div className="vetting-warning" style={{ marginBottom: '3rem', borderRadius: '4px' }}>
                <strong style={{ display: 'block', marginBottom: '0.5rem', fontSize: '1rem' }}>⚠️ Strict Vetting Standards (BS7858)</strong>
                As a premium security provider, all successful applicants will be subject to rigorous background checks to the BS7858 standard. This includes 5-year employment history verification, financial checks, and criminal record screening. 
              </div>

              <form className="page-contact-form">
                <div className="form-row" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1.5rem' }}>
                  <div className="form-group">
                    <label htmlFor="firstName">First Name *</label>
                    <input type="text" id="firstName" required style={{ padding: '1.25rem' }} />
                  </div>
                  <div className="form-group">
                    <label htmlFor="lastName">Last Name *</label>
                    <input type="text" id="lastName" required style={{ padding: '1.25rem' }} />
                  </div>
                </div>

                <div className="form-row" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1.5rem' }}>
                  <div className="form-group">
                    <label htmlFor="email">Email Address *</label>
                    <input type="email" id="email" required style={{ padding: '1.25rem' }} />
                  </div>
                  <div className="form-group">
                    <label htmlFor="phone">Phone Number *</label>
                    <input type="tel" id="phone" required style={{ padding: '1.25rem' }} />
                  </div>
                </div>

                <div className="form-row" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1.5rem' }}>
                  <div className="form-group">
                    <label htmlFor="role">Role Applied For *</label>
                    <select id="role" required style={{ padding: '1.25rem' }}>
                      <option value="">Select a role...</option>
                      <option value="cp">Close Protection Operative (London)</option>
                      <option value="cctv">Security Control Room Operator (Manchester)</option>
                      <option value="corporate">Corporate Security Officer (Birmingham)</option>
                      <option value="speculative">Speculative Application</option>
                    </select>
                  </div>
                  <div className="form-group">
                    <label htmlFor="siaNumber">SIA License Number (16 Digits) *</label>
                    <input type="text" id="siaNumber" maxLength="16" required style={{ padding: '1.25rem' }} />
                  </div>
                </div>

                <div className="form-group" style={{ marginTop: '1rem' }}>
                  <label htmlFor="cvUpload">Upload CV (PDF or DOCX only) *</label>
                  <input type="file" id="cvUpload" accept=".pdf,.doc,.docx" required className="file-input" style={{ border: '2px dashed var(--color-secondary-grey)', padding: '2rem !important', cursor: 'pointer' }} />
                </div>

                <div className="form-group" style={{ marginTop: '1.5rem' }}>
                  <label htmlFor="coverLetter">Cover Letter / Additional Information</label>
                  <textarea id="coverLetter" rows="5" placeholder="Briefly tell us why you are a good fit for Nightmark..." style={{ padding: '1.25rem' }}></textarea>
                </div>

                <div className="checkbox-group">
                  <label className="checkbox-label">
                    <input type="checkbox" required />
                    <span>I confirm that I have the right to work in the UK and understand that my employment is subject to successful BS7858 vetting. *</span>
                  </label>
                </div>

                <button type="submit" className="btn btn-primary btn-pill submit-btn" style={{ padding: '1.25rem 4rem', fontSize: '1rem', marginTop: '1rem' }}>
                  Submit Application
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>

    </div>
  );
};

export default Apply;